import { PrizeTypes } from "../brandVariables.types";

export const tclttPrize: PrizeTypes = {
  content: "",
  nameOf: "", // will be marked in color
  typeOfItem: "", // will be added after nameOf

  emptyPrize: "",
  prizeLeft: "",
  prizeRight: "",
};
